import { render } from "./RegisterSystemEspecificAcess.vue?vue&type=template&id=ca3526c2"
import script from "./RegisterSystemEspecificAcess.vue?vue&type=script&lang=js"
export * from "./RegisterSystemEspecificAcess.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__